var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16.933332mm",
    height: "16.933332mm",
    viewBox: "0 0 16.933332 16.933332",
    id: "svg8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-92.634079,-164.86571)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g1512",
    transform: "translate(-3.4745039,0.26726953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g856"
  }, /*#__PURE__*/React.createElement("circle", {
    cy: 173.06511,
    cx: 104.57525,
    id: "path833",
    style: {
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.05833328,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.98678415
    },
    r: 8.4666662
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    transform: "matrix(0.0416972,0,0,0.0416972,98.40087,165.99588)",
    id: "g1779"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1720"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.185659,0,0,1.1857846,-34.898504,-173.74701)",
    style: {
      strokeWidth: 5.35146618
    },
    id: "g1718"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333",
      fillOpacity: 1,
      strokeWidth: 5.35146618
    },
    d: "m 154.31703,128.96416 c -88.672998,0 -160.5459979,71.873 -160.5459979,160.547 0,63.891 37.4179999,118.894 91.4449999,144.734 l 5.025,-97.098 c 0,0 -9.452,-3.102 -11.521,-4.112 -20.048,-8.831 -34.612,-34.833 -34.612,-68.58 0,-36.825 28.559,-68.544 56.169998,-68.806 0.035,0 0.035,0 0.058,0 0.012,0 0.035,0 0.046,0 27.617,0.261 56.177,31.98 56.177,68.806 0,33.747 -14.582,59.738 -34.589,68.58 -0.157,0.069 -11.613,4.229 -11.613,4.229 l 5.612,107.961 c 12.315,3.031 25.119,4.81 38.37,4.81 17.87,0 34.984,-3.044 51.041,-8.424 l 4.973,-96.214 c -13.105,-2.882 -24.283,-11.225 -31.289,-21.692 -8.679,-13.001 6.681,-128.067 6.681,-128.067 h 9.992 v 107.978 h 9.923 v -107.966 h 10.852 v 107.99 h 9.876 v -107.99 h 11.259 v 107.99 h 9.91 v -107.99 h 7.668 c 0,0 15.36,115.066 6.67,128.067 -6.937,10.364 -18.01,18.683 -30.952,21.634 -0.232,0.082 -0.442,0.162 -0.442,0.162 l 4.322,82.761 c 47.823,-27.804 80.053,-79.46 80.053,-138.762 -0.024,-88.674 -71.897,-160.548 -160.559,-160.548 z",
    id: "path1712"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1722"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1724"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1726"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1728"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1730"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1732"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1734"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1736"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1738"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1740"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1742"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1744"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1746"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1748"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      strokeWidth: 6.34534979
    },
    id: "g1750"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.042c5eaef9e505e050295a82a849e8c6.svg";
export { ForwardRef as ReactComponent };